// DeckFrame — slide-deck chrome for projectType='deck'.
// Renders a presentation slide frame: subtle shadow-stack hint at bottom,
// 16:9 proportions, warm-orange accent border.

export const DeckFrame = {
  flow: 'column',
  width: '100%',
  height: '100%',
  round: 'inherit',
  overflow: 'visible',
  position: 'relative',

  // Shadow stack beneath — two ghost card layers suggesting a slide deck
  ShadowCard_1: {
    position: 'absolute',
    bottom: '-V',
    left: 'V',
    right: 'V',
    height: '100%',
    round: 'inherit',
    background: 'orange.08',
    border: '1px solid',
    borderColor: 'orange.12',
    zIndex: '-2',
    pointerEvents: 'none'
  },
  ShadowCard_2: {
    position: 'absolute',
    bottom: '-Y',
    left: 'W',
    right: 'W',
    height: '100%',
    round: 'inherit',
    background: 'orange.04',
    border: '1px solid',
    borderColor: 'orange.08',
    zIndex: '-3',
    pointerEvents: 'none'
  },

  // Main slide surface
  Slide: {
    flow: 'column',
    width: '100%',
    height: '100%',
    round: 'inherit',
    overflow: 'hidden',
    position: 'relative',
    zIndex: '1',

    // Slide header bar — slide controls / speaker icon
    ChromeBar: {
      flexShrink: '0',
      flow: 'x',
      align: 'center space-between',
      padding: 'V A',
      height: 'A2',
      background: 'black.3',
      borderBottom: '1px solid',
      borderColor: 'white.06',

      SlideIndicator: {
        flow: 'x',
        gap: 'W',
        align: 'center',
        Pip_1: { width: 'W', height: 'W', round: '50%', background: 'orange.85', flexShrink: '0' },
        Pip_2: { width: 'V', height: 'V', round: '50%', background: 'white.2', flexShrink: '0' },
        Pip_3: { width: 'V', height: 'V', round: '50%', background: 'white.2', flexShrink: '0' }
      },

      PageCount: {
        tag: 'span',
        text: '1 / ?',
        fontSize: 'Z1',
        color: 'white.25'
      }
    },

    // Slide canvas — thumbnail insets here
    Canvas: {
      flexGrow: '1',
      position: 'relative',
      overflow: 'hidden',
      background: 'black.18',

      EmptyState: {
        if: (el, s) => !s.screenshot && !s.screenshotDev && !s.icon,
        position: 'absolute',
        inset: '0',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 'Y',
        pointerEvents: 'none',

        Glyph: {
          fontSize: 'B2',
          color: 'orange.35',
          text: '▐▌',
          letterSpacing: '-0.05em'
        },
        Hint: {
          tag: 'span',
          text: 'First slide',
          fontSize: 'Z1',
          color: 'white.22',
          fontStyle: 'italic'
        }
      }
    }
  },

  // Left-border accent (orange)
  AccentBorder: {
    position: 'absolute',
    top: '0',
    left: '0',
    width: 'V',
    height: '100%',
    background: 'orange',
    opacity: '0.7',
    pointerEvents: 'none',
    zIndex: '2'
  }
}
